import { useMemoSelector } from '@spa/redux/hooks'
import classnames from 'classnames'
import type { PropsWithChildren, FC } from 'react'

import { payPeriodsSelectors } from '../../redux/selectors'

import styles from './LockedContainer.module.css'

type Props = {
  date: string
}

const LockedContainer: FC<PropsWithChildren<Props>> = ({ date, children }) => {
  const lockedDays = useMemoSelector(
    payPeriodsSelectors.getLockedDaysInTimerange
  )
  const isLocked = lockedDays[date]?.isLocked

  return (
    <div
      className={classnames(styles.Container, {
        [styles.LockedContainer]: isLocked
      })}
    >
      {children}
    </div>
  )
}

export default LockedContainer
